import { createFileRoute } from '@tanstack/react-router'

import { ChatView } from '@/views/chat/ChatView'

export const Route = createFileRoute('/')({
  component: ChatView,
})
